export default __webpack_public_path__ + "static/montserrat-v15-latin-800italic-bf45bfa14805969eda318973947bc42b.woff2";